import { segmentationStore } from '@segmentation/store/segmentationStore.ts';

const useSegmentationStore = () => {
  const scanId = segmentationStore((state) => state.scanId);
  const setScanId = segmentationStore((state) => state.setScanId);

  const jaws = segmentationStore((state) => state.jaws);
  const setJaws = segmentationStore((state) => state.setJaws);

  const lowerJawSegmentationMesh = segmentationStore((state) => state.lowerJawSegmentationMesh);
  const setLowerJawSegmentationMesh = segmentationStore((state) => state.setLowerJawSegmentationMesh);
  const upperJawSegmentationMesh = segmentationStore((state) => state.upperJawSegmentationMesh);
  const setUpperJawSegmentationMesh = segmentationStore((state) => state.setUpperJawSegmentationMesh);

  const segmentationPhase = segmentationStore((state) => state.segmentationPhase);
  const setSegmentationPhase = segmentationStore((state) => state.setSegmentationPhase);

  const upperJawTeeth = segmentationStore((state) => state.upperJawTeeth);
  const setUpperJawTeeth = segmentationStore((state) => state.setUpperJawTeeth);
  const lowerJawTeeth = segmentationStore((state) => state.lowerJawTeeth);
  const setLowerJawTeeth = segmentationStore((state) => state.setLowerJawTeeth);

  const update = segmentationStore((state) => state.update);

  const devReadyJaw = segmentationStore((state) => state.devReadyJaw);
  const setDevReadyJaw = segmentationStore((state) => state.setDevReadyJaw);

  const processingActive = segmentationStore((state) => state.processingActive);
  const processingPhase = segmentationStore((state) => state.processingPhase);
  const processingJaw = segmentationStore((state) => state.processingJaw);

  const reset = segmentationStore((state) => state.reset);

  return {
    scanId,
    setScanId,
    jaws,
    setJaws,
    lowerJawSegmentationMesh,
    setLowerJawSegmentationMesh,
    upperJawSegmentationMesh,
    setUpperJawSegmentationMesh,
    segmentationPhase,
    setSegmentationPhase,
    upperJawTeeth,
    setUpperJawTeeth,
    lowerJawTeeth,
    setLowerJawTeeth,
    update,
    devReadyJaw,
    setDevReadyJaw,
    processingActive,
    processingPhase,
    processingJaw,
    reset,
  };
};

export default useSegmentationStore;
